import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Tooltip, SvgIcon, SvgIconType } from '@integration-app/react';
import clsx from 'clsx';
import classes from './ActionBar.module.css';
import useEventStopPropagation from '../../../../hooks/useEventStopPropagation';
function ActionBarRoot({ children }) {
    return _jsx("div", { className: clsx(classes.actionBar), children: children });
}
const ActionBarGenericButton = forwardRef(({ className, iconType, tooltip, onClick, ...props }, ref) => {
    const handleOnClick = useEventStopPropagation((e) => onClick === null || onClick === void 0 ? void 0 : onClick(e));
    const button = (_jsx("button", { type: 'button', className: clsx(classes.actionBarButton, className), onClick: handleOnClick, ...props, ref: ref, children: iconType && _jsx(SvgIcon, { type: iconType }) }));
    if (tooltip) {
        return _jsx(Tooltip, { tooltip: tooltip, children: button });
    }
    return button;
});
ActionBarGenericButton.displayName = 'ActionBarGenericButton';
const ActionBarDeleteButton = forwardRef(({ className, ...props }, ref) => {
    return (_jsx(ActionBarGenericButton, { iconType: SvgIconType.Close, tooltip: 'Delete', "aria-label": 'Delete', className: clsx(className, classes.actionBarButton__delete), ...props, ref: ref }));
});
ActionBarDeleteButton.displayName = 'ActionBarDeleteButton';
export const ActionBar = Object.assign(ActionBarRoot, {
    GenericButton: ActionBarGenericButton,
    DeleteButton: ActionBarDeleteButton,
});
//# sourceMappingURL=index.js.map